<!--
  @author:chen.hao
  @time:2018/12/25
  @disc:多选联想tag展示形式，基于searchSelect封装
 -->

<template>
  <div class="tag-search-select">
    <search-select
      :multiple="false"
      v-bind="$attrs"
      v-model="selected"
      :disabled="disabled"
      clearable
      ref="select"></search-select>
    <el-button
      @click="handleAdd"
      icon="el-icon-plus"
      :disabled="!selected||selectedList.length>=limit"
      class="btn-add"></el-button>
    <div class="container-tag" v-if="selectedList.length">
      <el-tag
        v-for="item in selectedList"
        :key="item.id"
        :closable="!item.noClose&&!disabled"
        @close="handleRemove(item.id)">
        {{item.name}}{{ newCustomer && !firstCar ? '-新客' : (newCustomer && firstCar ? '-新客/首车' : null)}}
      </el-tag>
    </div>
  </div>
</template>

<script>
import SearchSelect from '../searchSelect/index'
export default {
  name: 'tagSearchSelect',
  components: { SearchSelect },
  props: ['val', 'disabled', 'limit', 'newCustomer', 'firstCar'],
  model: {
    prop: 'val',
    event: 'change'
  },
  data () {
    return {
      selected: '',
      selectedList: []
    }
  },
  computed: {
    finalList () {
      return this.selectedList.map(item => {
        return {
          id: item.id,
          name: item.name,
          deptId: item.deptId
        }
      })
    }
  },
  methods: {
    handleAdd () {
      const isExist = this.$lodash.find(this.selectedList, { id: this.selected.id })
      if (isExist) {
        this.$message.error('请勿添加重复信息！')
      } else {
        const obj = this.selected
        this.selectedList.push(this.selected)
        this.$emit('change', this.selectedList)
        this.$emit('add-success', obj)
      }
    },
    handleRemove (id) {
      let obj
      this.selectedList.forEach((val, index) => {
        if (val.id === id) {
          obj = val
          this.selectedList.splice(index, 1)
        }
      })
      this.$emit('change', this.finalList)
      this.$emit('remove-success', obj)
    },
    clearOption () {
      this.$refs.select.dataArr = []
    },
    setNoClose () {
      this.selectedList.forEach(item => {
        this.$set(item, 'noClose', true)
      })
    }
  },
  watch: {
    val: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.selectedList = [...newVal]
        }
      }
    },
    selectedList () {
      this.selected = ''
      this.clearOption()
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-add {
  margin-left: 10px;
}

.container-tag {
  margin-top: 5px;

  .el-tag {
    margin-right: 10px;
  }
}
</style>
